var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"microphone-button",class:{'microphone-active': !_vm.microphoneMuted},attrs:{"icon":""},on:{"click":_vm.toggleMicrophone}},[_c('v-icon',[_vm._v(_vm._s(_vm.microphoneMuted ? 'mdi-microphone-off' : 'mdi-microphone'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }